import AdSpot from './ad-spot';
import withAdRoot, { AdRoot } from './ad-root';
import withAdControl from './with-ad-control';
export { withAdRoot, AdRoot, withAdControl };
export default AdSpot;